var map = {
	"./decidim/avatar-multiuser.png": 24177,
	"./decidim/brands/facebook.svg": 22133,
	"./decidim/brands/google.svg": 35868,
	"./decidim/brands/twitter-x.svg": 30857,
	"./decidim/cc-badge.png": 58999,
	"./decidim/decidim-logo.svg": 33187,
	"./decidim/default-avatar.svg": 89367,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 53869,
	"./decidim/icons.svg": 28246,
	"./decidim/pattern.png": 49909,
	"./decidim/placeholder-card-g.svg": 15770,
	"./decidim/placeholder-card-l.svg": 86769,
	"./decidim/placeholder.jpg": 76592,
	"./decidim/remixicon.symbol.svg": 65538,
	"./decidim/vendor/social-share-button/douban.svg": 77189,
	"./decidim/vendor/social-share-button/email.svg": 95910,
	"./decidim/vendor/social-share-button/facebook.svg": 95566,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 58850,
	"./decidim/vendor/social-share-button/hacker_news.svg": 43270,
	"./decidim/vendor/social-share-button/linkedin.svg": 86460,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 49237,
	"./decidim/vendor/social-share-button/pinterest.svg": 56064,
	"./decidim/vendor/social-share-button/reddit.svg": 77530,
	"./decidim/vendor/social-share-button/telegram.svg": 47563,
	"./decidim/vendor/social-share-button/tumblr.svg": 72808,
	"./decidim/vendor/social-share-button/twitter.svg": 81771,
	"./decidim/vendor/social-share-button/vkontakte.svg": 54561,
	"./decidim/vendor/social-share-button/wechat.svg": 88052,
	"./decidim/vendor/social-share-button/whatsapp.svg": 90092,
	"./decidim/vendor/social-share-button/x.svg": 59758,
	"./decidim/vendor/social-share-button/xing.svg": 53418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60360;